import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getLabel } from '../utils';

const Input = React.forwardRef((props, ref) => (
  <input ref={ref} {...props} />
));

const TextArea = React.forwardRef((props, ref) => (
  <textarea ref={ref} {...props} />
));

const TextInput = React.forwardRef(
  (
    {
      name,
      type,
      className,
      label,
      helperText,
      value,
      onChange,
      onBlur,
      required,
      error,
      multiline,
      formGroupProps,
      labelProps,
      helperProps,
      ...others
    },
    ref,
  ) => {
    const Element = multiline ? TextArea : Input;

    return (
      <div
        className={classNames('form-group', formGroupProps.className)}
        style={formGroupProps.style}
      >
        {label && (
          <label
            htmlFor={name}
            className={labelProps.className}
            style={{
              ...(labelProps.style || {}),
              ...(error ? { color: 'red' } : {}),
            }}
          >
            {getLabel(label, required)}
          </label>
        )}
        <Element
          ref={ref}
          type={type}
          className={classNames('form-control', className)}
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          required={required}
          style={{
            ...(error ? { borderColor: 'red' } : {}),
          }}
          {...others}
        />

        {helperText && (
          <p
            style={{
              ...(helperProps.style || {}),
              ...(error ? { color: 'red' } : {}),
            }}
            className={classNames(helperProps.className)}
          >
            {helperText}
          </p>
        )}
      </div>
    );
  },
);

TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.node,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  required: PropTypes.bool,
  multiline: PropTypes.bool,
  formGroupProps: PropTypes.shape({
    className: PropTypes.string,
    style: PropTypes.object,
  }),
  labelProps: PropTypes.shape({
    className: PropTypes.string,
    style: PropTypes.object,
  }),
  helperProps: PropTypes.shape({
    className: PropTypes.string,
    style: PropTypes.object,
  }),
};

TextInput.defaultProps = {
  type: 'text',
  className: null,
  label: null,
  helperText: null,
  onChange: undefined,
  onBlur: () => {},
  required: false,
  multiline: false,
  formGroupProps: {},
  labelProps: {},
  helperProps: {},
};

export default TextInput;
